import {stage} from '../stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        endpoint: string;
        region: string;
    };
};

// FNP-1508: test and prod call the flexi-email-api deployed in the EMAIL accounts.
//
// Each endpoint was read from `appsync list-graphql-apis` in its OWN account. An
// AppSync endpoint host is not the api id and cannot be derived from one, so these
// are never constructed from another stage's URL.
//
// FNP-1582: dev and ide now call the flexi-email-api in flexi-email-dev (877133239133).
// They pointed at shared-services while that account held no AppSync API — the managed
// pipeline has test and prod stages only, so dev is reached by a hand-run deploy and
// nobody had run one. That deploy has now happened (api xnukth7ekvfuvopk5ne3fur57y), so
// the condition those two were waiting on is met.
//
// Until this moved, clicking Generate Test Data on localhost called the shared-services
// API, which has no generateTestMessages resolver, and failed with
// "Unknown type GenerateTestMessagesInput".
const appsync: ConfigShape = {
    // flexi-email-prod 803647806861
    prod: {
        endpoint: 'https://y2bp34x2krgidpyy5r7nqfqalq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    // flexi-email-test 630707069968
    test: {
        endpoint: 'https://c6d47qp2pnbldhfthy3km43hny.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    // flexi-email-dev 877133239133
    dev: {
        endpoint: 'https://3yqplcrzxnfs5knc6zvkv6szwq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    ide: {
        endpoint: 'https://3yqplcrzxnfs5knc6zvkv6szwq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
};

export const appSyncConfig = appsync[stage];
